var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass: "wrap-billet-head",
      style: { "background-image": "url('" + _vm.banner + "')" }
    },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "small-12 medium-8 large-6 medium-centered columns" },
          [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "form",
              {
                on: {
                  submit: function($event) {
                    $event.preventDefault()
                    $event.stopPropagation()
                    return _vm.search($event)
                  }
                }
              },
              [
                _c("CPFInput", {
                  attrs: {
                    placeholder:
                      "Digite seu CPF ou CNPJ para buscar o(s) boleto(s)"
                  },
                  model: {
                    value: _vm.cpf_cnpj,
                    callback: function($$v) {
                      _vm.cpf_cnpj = $$v
                    },
                    expression: "cpf_cnpj"
                  }
                }),
                _vm._v(" "),
                _vm.verified
                  ? _c(
                      "button",
                      {
                        staticClass: "default-button",
                        attrs: { type: "submit" }
                      },
                      [
                        _vm._v("Buscar "),
                        _c("i", {
                          staticClass: "fa fa-search",
                          attrs: { "aria-hidden": "true" }
                        })
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("vue-recaptcha", {
                  ref: "recaptcha",
                  attrs: {
                    loadRecaptchaScript: true,
                    size: "invisible",
                    sitekey: _vm.recaptcha_key
                  },
                  on: {
                    verify: _vm.verify,
                    expired: _vm.expired,
                    render: _vm.render,
                    error: _vm.onError
                  }
                })
              ],
              1
            )
          ]
        )
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h2", [
      _c("strong", [_vm._v("Inquilino:")]),
      _vm._v(" "),
      _c("br"),
      _vm._v("\n             Imprima seu boleto aqui")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }